var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdoge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#0FACF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32742 5.07158H8.38292C9.59455 5.07158 10.1964 5.03333 11.0998 5.11602C12.0037 5.21164 12.9077 5.58064 13.4927 6.2877C14.1817 7.10895 14.3831 8.21708 14.3375 9.24814C14.2925 10.2736 13.941 11.3491 13.1349 12.0494C12.42 12.6929 11.4193 12.9286 10.4698 12.9348C8.62367 12.941 6.78374 12.9348 4.93761 12.9348C4.73624 12.9218 4.50842 12.941 4.35261 12.8009C4.0798 12.5275 4.24236 11.9414 4.67774 11.9667C5.70486 11.9352 6.73817 11.9667 7.76586 11.9476C7.74617 11.0819 7.75911 10.2162 7.75911 9.3567C6.96599 9.34995 6.17905 9.3567 5.38649 9.3567C5.21042 9.34995 5.01524 9.34995 4.87911 9.2352C4.71655 9.08895 4.71655 8.84089 4.78799 8.6502C4.87911 8.43983 5.12605 8.40158 5.33417 8.40158C6.14024 8.39483 6.95305 8.40158 7.75855 8.40158C7.77205 7.61183 7.74617 6.82208 7.77205 6.03908C6.86811 6.03289 5.96474 6.03908 5.0608 6.03908C4.85942 6.03289 4.63217 6.03289 4.4758 5.89283C4.3138 5.68245 4.34642 5.3832 4.48255 5.17283C4.74242 5.0457 5.04167 5.07158 5.32742 5.07158ZM8.8903 8.40158C9.26042 8.40776 9.63111 8.3757 10.0018 8.42689C10.4439 8.49045 10.4439 9.26726 9.99505 9.33083C9.63111 9.3882 9.25424 9.34995 8.88355 9.3567C8.8903 10.1076 8.88355 10.853 8.88355 11.6039C8.8903 11.7316 8.89649 11.9223 9.05905 11.9352C9.50117 11.9735 9.88592 11.9605 10.3854 11.9605C11.1262 11.9926 11.9064 11.7636 12.4262 11.222C12.9594 10.6555 13.1546 9.86633 13.1675 9.11426C13.1872 8.28064 13.0309 7.36377 12.4194 6.73939C11.8676 6.17914 11.0357 5.98845 10.2617 6.03289C9.82067 6.03289 9.44267 6.01995 9.03317 6.0582C8.90324 6.09645 8.89649 6.25564 8.8903 6.37039V8.40158Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdoge);
export default __webpack_public_path__ + "static/media/edoge.f675a64e751af2c9ff2e466001ad37ba.svg";
export { ForwardRef as ReactComponent };